import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@mui/material'
import { isNil } from 'lodash'
import { push } from '@lagunovsky/redux-react-router'
import { useDispatch } from 'react-redux'
import { PATH_STATION } from '../../home/constants/RouteConstants'
import { createIconMaterialAssignment } from '../../utils/MaterielUtils'
import { getStationTypeFromName, getStationTypeNameFromTypeCode } from '../../utils/StationUtils'
import { MATERIEL_STATE_ON_SITE_ID } from '../constants/MaterielStateConstants'

export const getStationLink = (siteType, siteCode) => {
    const siteTypeName = siteType && getStationTypeNameFromTypeCode(siteType)
    const linkTypeName = siteTypeName && getStationTypeFromName(siteTypeName)
    return linkTypeName && !isNil(siteCode) ? `${PATH_STATION}/${linkTypeName}/${siteCode}/materiel` : ''
}

const MaterielAssignmentLink = ({
    materiel = {},
}) => {
    const dispatch = useDispatch()
    const { assignment, statusCode, siteType, siteCode } = materiel

    if (statusCode !== MATERIEL_STATE_ON_SITE_ID) {
        return null
    }

    const icon = createIconMaterialAssignment(assignment, siteType)
    const stationLink = getStationLink(siteType, siteCode)

    if (!icon || !stationLink) {
        return icon
    }

    return (
        <Link
            sx={{ cursor: 'pointer' }}
            onClick={e => {
                e.stopPropagation()
                dispatch(push(stationLink))
            }}
        >
            {icon}
        </Link>
    )
}

MaterielAssignmentLink.propTypes = {
    materiel: PropTypes.shape({
        assignment: PropTypes.string,
        statusCode: PropTypes.number,
        siteType: PropTypes.number,
        siteCode: PropTypes.number,
    }),
}

export default MaterielAssignmentLink